// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-cart{position:relative;width:-moz-fit-content;width:fit-content;display:block;margin:0 auto;color:#006c6f;--fa-counter-scale:.35;--fa-top:-.2em;--fa-right:-.2em}.icon-cart .fa-layers-counter{background:#e88e0c;position:absolute;font-family:Poppins,sans-serif;font-weight:300;font-style:normal}", ""]);
// Exports
module.exports = exports;
